import { ApolloError } from '@apollo/client';
import { createContext, useContext } from 'react';

import { Locale, WhatsAppActiveLocale } from 'modules/domains/template';
import noop from 'utils/noop';

export interface LocalesQueryContextState {
  errorMessage: string | ApolloError;
  hasError: boolean;
  isLoading: boolean;
  refetch: () => void;
  allProjectLocales: Locale[];
  activeTemplateLocales: Locale[];
  templateDefaultLocale: Locale;
  invalidWhatsAppLocales?: Locale[];
  validWhatsAppLocales?: Locale[];
  activeWhatsAppTemplateLocales?: WhatsAppActiveLocale[];
}

export const LocalesQueryContext = createContext<LocalesQueryContextState>({
  errorMessage: '',
  hasError: false,
  isLoading: false,
  refetch: noop,
  allProjectLocales: [],
  activeTemplateLocales: [],
  templateDefaultLocale: {} as Locale,
  invalidWhatsAppLocales: [],
  validWhatsAppLocales: [],
  activeWhatsAppTemplateLocales: [],
});

export const useLocalesQueryContext = () => useContext(LocalesQueryContext);
